import { colors } from "../../Styles";

export function Percent({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      <path d="M207.74,43.14c-1.89-1.26-4.16-1.72-6.38-1.28-2.23.44-4.15,1.72-5.41,3.61l-122.55,183.06c-1.26,1.89-1.72,4.15-1.27,6.38.44,2.23,1.72,4.15,3.61,5.41,1.41.94,3.04,1.44,4.72,1.44,2.84,0,5.49-1.41,7.07-3.77L210.07,54.93c2.61-3.9,1.56-9.18-2.33-11.79Z"/>
      <circle cx="181.73" cy="204.2" r="26.04"/>
      <circle cx="101.73" cy="77.01" r="26.04"/>
    </svg>
  );
}
